import {PatientRecordWindow} from '@/modules/patients/components/patient-record-window/patient-record-window'
import {dialog} from '@cypro/ui/components'

export function openPatientRecordWindow(patientId: string) {
  try {
    dialog.remove('patient-record')
  } catch {}

  return dialog.open('patient-record', {
    id: 'patient-record',
    children: <PatientRecordWindow patientId={patientId} />,
    size: 'full',
    contentProps: {
      height: '100vh',
    },
    positionerProps: {
      p: '0',
    },
  })
}
